module.exports = __webpack_public_path__ + "media/npc_dota_hero_techies.a5358ff5.webm";